import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=12d9817e&scoped=true&"
import script from "./DropdownItem.vue?vue&type=script&lang=js&"
export * from "./DropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=12d9817e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d9817e",
  null
  
)

export default component.exports